import { ChangeDetectionStrategy, Component, inject, input, model, OnInit, output } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { CommonModule } from '@angular/common';
import { Conta } from '../../../banco-conta-convenio/banco-conta-convenio';
import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-conta-detalhe',
    standalone: true,
    imports: [DialogoPadraoDirective, CommonModule, ReactiveFormsModule, ButtonModule, Dialog, InputTextModule, MessageModule, ToggleSwitch, CanDirective],
    templateUrl: './conta-detalhe.html',
    styleUrl: './conta-detalhe.scss'
})
/** Modal de novo/edição de conta bancária. */
export class ContaDetalhe implements OnInit {
    protected readonly roleBancosEditar = PERMISSOES.configuracoes.bancos.editar;

    private readonly fb = inject(FormBuilder);

    conta = input<Conta | null>(null);
    showDialog = model.required<boolean>();
    salvo = output<Conta>();

    contaForm!: FormGroup<{
        agencia: FormControl<string>;
        agenciaDv: FormControl<string>;
        conta: FormControl<string>;
        contaDv: FormControl<string>;
        compartilhada: FormControl<boolean>;
        finalidade: FormControl<string>;
    }>;
    formSubmitted = false;

    ngOnInit(): void {
        this.contaForm = this.fb.nonNullable.group({
            agencia: ['', [Validators.required]],
            agenciaDv: [''],
            conta: ['', [Validators.required]],
            contaDv: [''],
            compartilhada: [false],
            finalidade: ['']
        });
    }

    onDialogShow(): void {
        this.formSubmitted = false;
        const currentConta = this.conta();
        if (currentConta) {
            this.contaForm.patchValue({
                agencia: currentConta.agencia,
                agenciaDv: currentConta.agenciaDv,
                conta: currentConta.conta,
                contaDv: currentConta.contaDv,
                compartilhada: currentConta.compartilhada,
                finalidade: currentConta.finalidade
            });
        } else {
            this.contaForm.reset({ compartilhada: false });
        }
    }

    hideDialog(): void {
        this.showDialog.set(false);
    }

    isInvalid(controlName: string): boolean {
        const control = this.contaForm.get(controlName);
        return (control?.invalid && (control?.dirty || control?.touched || this.formSubmitted)) || false;
    }

    salvar(): void {
        this.formSubmitted = true;
        if (this.contaForm.invalid) {
            return;
        }

        const formValue = this.contaForm.getRawValue();
        const contaSalva: Conta = {
            ...(this.conta() || { id: '', parentId: '', banco: '', usuario: '', descricao: '' }),
            agencia: formValue.agencia,
            agenciaDv: formValue.agenciaDv,
            conta: formValue.conta,
            contaDv: formValue.contaDv,
            compartilhada: formValue.compartilhada,
            finalidade: formValue.finalidade
        };

        this.salvo.emit(contaSalva);
        this.hideDialog();
    }
}
